/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Step_ContentInputs */

const en_directory_agents_step_content = /** @type {(inputs: Directory_Agents_Step_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Researches the product site and writes the full listing content per the Seek AI content spec — English required, Chinese optional.`)
};

const zh_directory_agents_step_content = /** @type {(inputs: Directory_Agents_Step_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`研究产品官网，按 Seek AI 内容规范撰写完整的 listing 内容——英文必填，中文选填。`)
};

/**
* | output |
* | --- |
* | "Researches the product site and writes the full listing content per the Seek AI content spec — English required, Chinese optional." |
*
* @param {Directory_Agents_Step_ContentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_step_content = /** @type {((inputs?: Directory_Agents_Step_ContentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Step_ContentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_step_content(inputs)
	return zh_directory_agents_step_content(inputs)
});
export { directory_agents_step_content as "directory.agents.step_content" }